import React from 'react';
import {
  withRouter,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Tooltip } from '@material-ui/core';
import { useCommonStyles } from './Styles';
import { permitted } from '../../common/helpers';
import TitleSetter from './TitleSetter';


// Encounter few problems when trying to wrap this to component
const renderTab = (tabItem) => {
  if (tabItem.tooltip) {
    return (
      <Tooltip
        placement="bottom"
        key={tabItem.label}
        title={tabItem.tooltip}
        arrow
      >
        <Tab
          key={tabItem.label}
          label={tabItem.icon ? (
            <div>
              <tabItem.icon style={{ verticalAlign: 'middle', marginRight: 5 }} />
              {tabItem.label}
            </div>
          ) : tabItem.label}
        />
      </Tooltip>
    );
  }
  return (
    <Tab
      key={tabItem.label}
      label={tabItem.icon ? (
        <div>
          <tabItem.icon style={{ verticalAlign: 'middle', marginRight: 5 }} />
          {tabItem.label}
        </div>
      ) : tabItem.label}
    />
  );
};

function RoutableTabContainer(props) {
  const {
    match,
    tabItems: tabItemsUnfiltered,
    permissionEdges,
    location,
    history,
    titlePrefix,
  } = props;

  const classes = useCommonStyles();
  const tabItems = permitted(tabItemsUnfiltered, permissionEdges, 'permission');
  const [members] = React.useState({
    tabURLToItem: Object.fromEntries(tabItems.map((item, i) => [i, item.url])),
  });

  const getTabIndex = () => {
    for (let tabIndex = 0; tabIndex < tabItems.length; tabIndex += 1) {
      if (match) {
        const fullPath = `${match.url}/${tabItems[tabIndex].url}`;
        if (location.pathname.startsWith(fullPath)) {
          return tabIndex;
        }
      }
    }
    return null;
  };

  const onTabChange = (event, tabIndex) => {
    const targetPath = `${match.url}/${members.tabURLToItem[tabIndex]}`;
    history.push(targetPath);
  };

  const tabIndex = getTabIndex();

  return (
    <div className={classes.pageRoot}>
      <Paper square>
        <Tabs
          value={tabIndex}
          onChange={onTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {
            tabItems.map(
              tabItem => renderTab(tabItem),
            )
          }
        </Tabs>
      </Paper>
      <Switch>
        {
          tabItems.map(
            (tabItem) => {
              let childProps = {};
              const CompClass = tabItem.comp;

              const overrideTitlePrefix = tabItem.titlePrefix && tabItem.titlePrefix(props);
              const titlePrefixSet = overrideTitlePrefix || (titlePrefix && titlePrefix(props)) || '';
              if (tabItem.propCopyFn) {
                childProps = tabItem.propCopyFn(props);
              }
              const titleSuffix = tabItem.titleLabel || tabItem.label;
              const title = `${titlePrefixSet}${titleSuffix}`;
              return (
                <Route
                  key={tabItem.label}
                  path={`${match.url}/${tabItem.url}`}
                  render={
                    () => (
                      <>
                        <TitleSetter title={title} />
                        <CompClass {...childProps} />
                      </>
                    )
                  }
                />);
            },
          )
        }
        {
          tabItems.length > 0
          && <Redirect to={`${match.url}/${tabItems[0].url}`} />
        }
      </Switch>
    </div>
  );
}

const StyledRoutableRoutableTabContainer = withRouter(RoutableTabContainer);

export const withTabItems = (tabItems, titlePrefix) => (props) => {
  const { permissionEdges } = props;
  return (
    <StyledRoutableRoutableTabContainer
      tabItems={tabItems}
      permissionEdges={permissionEdges}
      titlePrefix={titlePrefix}
    />
  );
};

export default StyledRoutableRoutableTabContainer;
